import Vue from 'vue'
import en from '@/lang/locale/en.json'
import nl from '@/lang/locale/nl.json'
import fr from '@/lang/locale/fr.json'
import de from '@/lang/locale/de.json'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const locale = 'NL';
const messages = {
    EN: en,
    NL: nl,
    FR: fr,
    DE: de
};

const i18n = new VueI18n({
    locale,
    messages
});

export default i18n